import React, { useState } from "react";
import { Box, Button, Typography, Fade } from "@mui/material";
import { useNavigate } from "react-router-dom";

import SessionExpiredImg from "../../../../assets/ilustrations/SessionExpired.png";

function SessionExpired({
  alt = "Sessão expirada",
  title = "Sua sessão expirou",
  description = "Por segurança, sua sessão foi encerrada. Faça login novamente para continuar.",
  buttonText = "Fazer login novamente",
}) {
  const [imageLoaded, setImageLoaded] = useState(false);
  const navigate = useNavigate();

  const handleRedirect = () => {
    localStorage.clear(); // limpa tokens
    sessionStorage.clear();
    navigate("/", { replace: true });
  };

  return (
    <Fade in={imageLoaded} timeout={400}>
      <Box
        sx={{
          width: "100%",
          height: "100vh",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          px: 2,
        }}
      >
        <Box
          sx={{
            width: "100%",
            maxWidth: 420,
            textAlign: "center",
          }}
        >
          {/* IMAGEM */}
          <Box
            component="img"
            src={SessionExpiredImg}
            alt={alt}
            onLoad={() => setImageLoaded(true)}
            sx={{
              width: "100%",
              maxWidth: 320,
              height: "auto",
              margin: "0 auto 16px",
              display: "block",
            }}
          />

          {/* TÍTULO */}
          <Typography
            fontWeight={700}
            sx={{
              fontSize: { xs: 18, sm: 22 },
              color: "#8033F4",
              mb: 1,
            }}
          >
            {title}
          </Typography>

          {/* DESCRIÇÃO */}
          <Typography
            sx={{
              fontSize: { xs: 14, sm: 15 },
              color: "text.secondary",
              mb: 3,
            }}
          >
            {description}
          </Typography>

          {/* BOTÃO */}
          <Button
            variant="contained"
            sx={{
              width: "100%",
              maxWidth: 280,
            }}
            onClick={handleRedirect}
          >
            {buttonText}
          </Button>
        </Box>
      </Box>
    </Fade>
  );
}

export default SessionExpired;